import {TDataSourceType} from "../index";
import {ObjectTypeId} from "./ObjectTypeId";

export const Syncfield_User = [
    'AAuthorizedPositionName',
    'ABusinessNumber',
    'ACompany',
    'ACostCentre1',
    'ACostCentre10',
    'ACostCentre2',
    'ACostCentre3',
    'ACostCentre4',
    'ACostCentre5',
    'ACostCentre6',
    'ACostCentre7',
    'ACostCentre8',
    'ACostCentre9',
    'ACostCentreName1',
    'ACostCentreName2',
    'ACostCentreName3',
    'ACostCentreName4',
    'ACostCentreName5',
    'AEmployeeNumber',
    'AEmployeeTypeCodeDescription',
    'AEmploymentPositionPercentage',
    'ALeaveFromDate',
    'ALeavePercentage',
    'ALeaveReason',
    'ALeaveToDate',
    'ALeaveType',
    'ALocation',
    'APaymentLocationName',
    'APaymentLocationValue',
    'APositionCategoryNumber',
    'APositionCodeCode',
    'APositionCodeId',
    'APositionCodeName',
    'APositionEndDate',
    'APositionId',
    'APositionManager',
    'APositionPercentage',
    'APositionPublicCode',
    'APositionPublicCodeName',
    'APositionSalaryEndDate',
    'APositionStartDate',
    'APositionTypeName',
    'APositionTypeValue',
    'APrimaryPosition',
    'AQualificationCode',
    'AServicePlaceId',
    'AServicePlaceName',
    'AShiftWork',
    'AUnitId',
    'AUnitName',
    'AUserId',
    'AValidFromDate',
    'AWeeklyHours',
    'AWorkClassificationName',
    'AYearlyHours',
    'AauthDataSource',
    'AccessLevel',
    'AeduPositionEndDate',
    'AeduPositionName',
    'AeduPositionOrgId',
    'AeduPositionOrgName', // staff
    'AeduPositionPercentage',
    'AeduPositionStartDate',
    'AenrollmentClass',
    'AenrollmentCode',
    'AenrollmentEndDate',
    'AenrollmentLevel',
    'AenrollmentOrgId',
    'AenrollmentOrgName', // learner
    'AenrollmentProgramme',
    'AenrollmentStartDate',
    'AhourlyWages',
    'AlternateDepartment',
    'AmanualPosition',
    'ApprovedDate',
    'Aproject',
    'Assistant',
    'AtitleSsb',
    'AuthDataSource',
    'AuthorizedPositionName',
    'AzureAdLastLogon',
    'BankAccountNr',
    'Birthdate',
    'BusinessNumber',
    'Class',
    'Cn',
    'Company',
    'CostCentre',
    'CostCentre10',
    'CostCentre2',
    'CostCentre3',
    'CostCentre4',
    'CostCentre5',
    'CostCentre6',
    'CostCentre7',
    'CostCentre8',
    'CostCentre9',
    'Country',
    'Created',
    'Deleted',
    'Department',
    'DepartmentNumber',
    'DepartmentPositionCodes',
    'Description',
    'DisplayName',
    'EduSourceId',
    'Education',
    'EducationValue',
    'Email',
    'EmployeeNumber',
    'EmployeeStatusCode',
    'EmployeeType',
    'EmployeeTypeCode',
    'EmployeeTypeCodeDescription',
    'ExpiryDate',
    'ExtendLife',
    'ExtensionAttribute1',
    'ExtensionAttribute10',
    'ExtensionAttribute11',
    'ExtensionAttribute12',
    'ExtensionAttribute13',
    'ExtensionAttribute14',
    'ExtensionAttribute15',
    'ExtensionAttribute16',
    'ExtensionAttribute17',
    'ExtensionAttribute18',
    'ExtensionAttribute19',
    'ExtensionAttribute2',
    'ExtensionAttribute20',
    'ExtensionAttribute21',
    'ExtensionAttribute22',
    'ExtensionAttribute23',
    'ExtensionAttribute24',
    'ExtensionAttribute25',
    'ExtensionAttribute26',
    'ExtensionAttribute27',
    'ExtensionAttribute28',
    'ExtensionAttribute29',
    'ExtensionAttribute3',
    'ExtensionAttribute30',
    'ExtensionAttribute4',
    'ExtensionAttribute5',
    'ExtensionAttribute6',
    'ExtensionAttribute7',
    'ExtensionAttribute8',
    'ExtensionAttribute9',
    'ExternalInitials',
    'Fax',
    'Gender',
    'GivenName',
    'HomeCountryCode',
    'HomePostalAddress',
    'HomePostalArea',
    'HomePostalCode',
    'HomeStreetAddress',
    'HourlyWages',
    'Id',
    'IdentityType', // Staff | Learner
    'Initials',
    'Language',
    'LastEmployed',
    'Location',
    'Mail',
    'Manager',
    'ManagerOf',
    'Manual',
    'ManualMerge',
    'MiddleName',
    'Mobile',
    'Name',
    'ObjectTypeId',
    'OfficeTelephone',
    'OrgUnitnr',
    'ParentDepartment',
    'ParentDepartmentNumber',
    'PositionCode',
    'PositionName',
    'PositionPercentage',
    'PositionPublicCodeName',
    'PostalAddress',
    'PostalAddress1',
    'PostalArea',
    'PostalCode',
    'PrivateEmail',
    'PrivatePhone',
    'Project',
    'PublicPositionCode',
    'QualificationCode',
    'RejectedDate',
    'ResourceType',
    'SalaryCode',
    'ServicePlace',
    'Sex',
    'Socialsecuritynumber',
    'SourceId',
    'Start',
    'Stop',
    'Surname',
    'Swiftcode',
    'SystemRoles',
    'TelephoneNumber',
    'Title',
    'TitleSsb',
    'Upn',
    'UserId',
    'UserName',
    'UserPassword',
    'WebUserId',
    'WorkClassification',
    'WorkPhone',
    'WorkTasks',
    'WwwUrl',
] as const

export const Syncfield_Department = [
    'AuthDataSource',
    'Company',
    'CostCentre',
    'Created',
    'Deleted',
    'Department',
    'DepartmentNumber',
    'EduSchoolType',
    'EduSchoolTypeSrc',
    'EduSourceId',
    'Email',
    'ExpiryDate',
    'ExtensionAttribute1',
    'ExtensionAttribute2',
    'ExtensionAttribute3',
    'ExtensionAttribute4',
    'ExtensionAttribute5',
    'Fax',
    'HomePostalAddress',
    'HomePostalArea',
    'HomePostalCode',
    'HomeStreetAddress',
    'Id',
    'Manager',
    'Manual',
    'Name',
    'OrgUnitType',
    'OrgUnitnr',
    'Orgnr',
    'ParentDepartmentNumber',
    'PermanantManager',
    'PostalAddress',
    'PostalArea',
    'PostalCode',
    'SchoolUnitCode',
    'SourceId',
    'TelephoneNumber',
    'WwwUrl',
] as const

export const Syncfield_Group = [
    'ApplicationMessageId',
    'AuthDataSource',
    'AvailableToRuleSetId',
    'Created',
    'Deleted',
    'Description',
    'EduOrgId',
    'EduSchoolType',
    'EduSchoolTypeSrc',
    'EduSourceId',
    'ExpiryDate',
    'ExtensionAttribute1',
    'ExtensionAttribute2',
    'ExtensionAttribute3',
    'ExtensionAttribute4',
    'ExtensionAttribute5',
    'ExtensionAttribute6',
    'GroupType',
    'Id',
    'Level',
    'Mail',
    'ManagedByRuleSetId',
    'Manager',
    'Manual',
    'MemberRuleSetId',
    'Name',
    'OrgUnitType',
    'OrgUnitnr',
    'Parent',
    'ParentDepartmentNumber',
    'RejectionMessageId',
    'SourceId',
    'Start',
    'Stop',
    'SystemRoleFilterId',
    'SystemRoles',
] as const


export const Syncfield_FormData = [
    'ApprovedDate',
    'Created',
    'CreatedBy',
    'Department',
    'DepartmentNumber',
    'Email',
    'ExpiryDate',
    'ExtensionAttribute1',
    'ExtensionAttribute10',
    'ExtensionAttribute11',
    'ExtensionAttribute12',
    'ExtensionAttribute13',
    'ExtensionAttribute14',
    'ExtensionAttribute15',
    'ExtensionAttribute2',
    'ExtensionAttribute3',
    'ExtensionAttribute4',
    'ExtensionAttribute5',
    'ExtensionAttribute6',
    'ExtensionAttribute7',
    'ExtensionAttribute8',
    'ExtensionAttribute9',
    'FormId',
    'FormName',
    'GivenName',
    'Manager',
    'Mobile',
    'RejectedDate',
    'Socialsecuritynumber',
    'SourceId',
    'Surname',
    'SystemId',
    'SystemRoles',
] as const

export const Syncfield_ExternalContact = [
    'GivenName',
    'Socialsecuritynumber',
    'SourceId',
    'Surname',
] as const

export const Syncfield_History = [
    'EntryType',
    'AttributeName',
    'AttributeType',
    'OldValue',
    'NewValue',
    'Registered',
    'ObjectId',
    'LastError',
    'TargetGUID',
    'Exported',
    'Comment',
    'SyncStepId',
] as const

export const Syncfield_Event = [
    'AddPermission',
    'DeletePermission',
    'EditPermission',
    'AddTemplate',
    'DeleteTemplate',
    'EditTemplate',
    'Create',
    'Edit',
    'Delete',
    'PermanentDelete',
    'Recover',
    'Activate',
    'Deactivate',
    'AddMember',
    'RemoveMember',
] as const

export const Syncfield_User_ImportType: Partial<Record<TSyncfield_User, TDataSourceType | TDataSourceType[]>> = {
    // edu
    'AeduPositionEndDate':    'edu',
    'AeduPositionName':       'edu',
    'AeduPositionOrgId':      'edu',
    'AeduPositionOrgName':    'edu',
    'AeduPositionPercentage': 'edu',
    'AeduPositionStartDate':  'edu',
    'AenrollmentClass':       'edu',
    'AenrollmentCode':        'edu',
    'AenrollmentEndDate':     'edu',
    'AenrollmentLevel':       'edu',
    'AenrollmentOrgId':       'edu',
    'AenrollmentOrgName':     'edu',
    'AenrollmentProgramme':   'edu',
    'AenrollmentStartDate':   'edu',
    'EduSourceId':            'edu',
    'IdentityType':           'edu',

    // both
    // 'AAuthDataSource':        ['edu', 'hr'], // awaiting API change
    'AuthDataSource':         ['edu', 'hr'],
    'Birthdate':              ['edu', 'hr'],
    'Created':                ['edu', 'hr'],
    'Deleted':                ['edu', 'hr'],
    'DisplayName':            ['edu', 'hr'],
    'ExtendLife':             ['edu', 'hr'],
    'GivenName':              ['edu', 'hr'],
    'Id':                     ['edu', 'hr'],
    'MiddleName':             ['edu', 'hr'],
    'Sex':                    ['edu', 'hr'],
    'Surname':                ['edu', 'hr'],
    'UserName':               ['edu', 'hr'],

    // hr (default)
} as const

export const Syncfield_Group_ImportType: Partial<Record<TSyncfield_Group, TDataSourceType | TDataSourceType[]>> = {
    // edu
    'EduOrgId':               'edu',
    'EduSchoolType':          'edu',
    'EduSchoolTypeSrc':       'edu',
    'EduSourceId':            'edu',

    // both (default)
} as const

export const Syncfield_Department_ImportType: Partial<Record<TSyncfield_Department, TDataSourceType | TDataSourceType[]>> = {
    //edu
    'EduSchoolType':          'edu',
    'EduSchoolTypeSrc':       'edu',
    'EduSourceId':            'edu',
    'SchoolUnitCode':         'edu'

    // both (default)
} as const

export const Syncfield_ObjectTypeId_DataSource: Partial<Record<ObjectTypeId, typeof Syncfield_User_ImportType | typeof Syncfield_Group_ImportType | typeof Syncfield_Department_ImportType>> = {
    [ObjectTypeId.User]: Syncfield_User_ImportType,
    [ObjectTypeId.Group]: Syncfield_Group_ImportType,
    [ObjectTypeId.Department]: Syncfield_Department_ImportType,
}

export type TSyncfield_User = typeof Syncfield_User[number]
export type TSyncfield_Department = typeof Syncfield_Department[number]
export type TSyncfield_Group = typeof Syncfield_Group[number]
export type TSyncfield_FormData = typeof Syncfield_FormData[number]
export type TSyncfield_ExternalContact = typeof Syncfield_ExternalContact[number]
export type TSyncfield_History = typeof Syncfield_History[number]
export type TSyncfield_Event = typeof Syncfield_Event[number]

export type TSyncfield = TSyncfield_User | TSyncfield_Group | TSyncfield_Department | TSyncfield_FormData | TSyncfield_ExternalContact | TSyncfield_History;
